import React, { useState } from "react"
import Container from "./Container"
import Showcase from "./Showcase"
import handleViewport from "react-in-viewport"
const ShowcaseContainer = handleViewport(Showcase)
export const SectionHeading = ({ children }) => (
  <h2 className="text-xl font-medium text-center md:text-left text-text-primary sm:text-2xl md:text-3xl lg:text-4xl">
    {children}
  </h2>
)
export const Nanum = ({ children }) => (
  <span className="text-lg font-normal md:text-base lg:text-2xl font-nanum text-text-secondary1">
    {children}
  </span>
)
export default function Projects() {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div className="my-25 ">
      <Container>
        <span className="psuedo__title"></span>
        <div className="flex flex-col items-center mb-10 md:items-baseline md:flex-row ">
          {/* <div className="flex self-center border border-red-100 md:self-start"> */}
          <SectionHeading>Projects</SectionHeading>
          <div className="ml-4"></div>
          <Nanum>I've been working on</Nanum>
          {/* </div> */}
        </div>
        <Showcase />
      </Container>
    </div>
  )
}
